/**
 * Pure helper for "scroll a list item to the vertical center of its ScrollView".
 *
 * Given an item's offset within the scroll content (`itemY`), its height, and
 * the visible viewport height, returns the scroll offset that centers the item.
 * Clamped to ≥ 0 so a short/near-top list never asks for a negative offset — and
 * because ScrollView itself clamps the max offset, a list that isn't actually
 * scrollable (content ≤ viewport) stays put, which is the desired "just open it,
 * don't scroll" behavior for short lists.
 */
export function centerScrollOffset(
  itemY: number,
  itemHeight: number,
  viewportHeight: number,
): number {
  return Math.max(0, itemY + itemHeight / 2 - viewportHeight / 2)
}
